import BuilderModel from '~/models/tracked/builderModel'
import {IReferencePath, IReferencePathNodeSpecific, IReferencePathNodeGeneral, IReferencePathServiceType} from '~/interfaces/referencePathInterfaces'
import IRepo from '~/interfaces/repo'
import Repo from '~/state/modules/repo'
import {ReferenceNodeType} from "~/enums/referenceNodeType"
import ReferencePathServiceFactory from "~/services/referencePathServices/referencePathServiceFactory"
import {FileAttachmentType} from "~/enums/fileAttachmentType";
import { Logger } from '~/services/logger'
import ObjectModelRelation from '~/models/objectModelRelations/objectModelRelation'
import FormElement from '../../../formability/form_builder/models/formElements/formElement'
import ObjectModelProperty from '~/models/objectModelProperties/objectModelProperty'

export class ReferencePathNode extends BuilderModel implements IReferencePathNodeGeneral {
  reference_type: ReferenceNodeType
  reference_id: string
  inverse: boolean; // optional

  constructor(parent: IReferencePath, json, options?: { nameInParent?: string }) {
    super()
    this.parent = parent
    this._nameInParent = options?.nameInParent || 'nodes'
    this.defineClientId(json.client_id)
    this.defineProperty('reference_type', json.reference_type)
    this.defineProperty('reference_id', json.reference_id)
    this.defineProperty('inverse', json.inverse)
  }

  // ******************** RELATIONS AND REPOS ******************** //
  static repo: IRepo<ReferencePathNode> = new Repo<ReferencePathNode>('referencePathNodes', ReferencePathNode, {})
  repo: IRepo<this>

  addToRepo(): void {
    ReferencePathNode.repo.add(this)
  }

  get collectionKey() {
    return this._nameInParent
  }

  get rootName(): string {
    return this._nameInParent
  }

  get isCollectionRoot(): boolean {
    return true
  }

  // ******************** RELATIONS AND REPOS END ******************** //

  reference(): any {
    return this.service.reference();
  }

  get service(): IReferencePathServiceType {
    return ReferencePathServiceFactory.create(this as IReferencePathNodeSpecific);
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    return this.service.canLinkTo(node)
  }

  get isSingleUploader(): boolean {
    const reference = this.reference();
    if (!reference) return false;

    switch (this.reference_type) {
      case ReferenceNodeType.ProcessFlowVariable:
        return reference.isVariableFile() && reference.is_single;
      case ReferenceNodeType.FormElement:
        return reference.isUploader && !reference.is_multiple;
      case ReferenceNodeType.ObjectModelProperty:
        return reference.isUploader && reference.file_attachment_type === FileAttachmentType.SingleFile;
      default:
        return false;
    }
  }

  clearReferenceId(): void {
    this.reference_id = null
  }

  get label(): string {
    switch (this.reference_type) {
      case ReferenceNodeType.OriginalSubmitter:
        return 'Original Submitter'
      case ReferenceNodeType.RecordHolder:
        return 'Record Holder'
      case ReferenceNodeType.AllCompleters:
        return 'All Completers'
      case ReferenceNodeType.StepCompleter:
        return 'Step Completer'
      case ReferenceNodeType.FormElement:
      case ReferenceNodeType.ObjectModelRelation:
      case ReferenceNodeType.ObjectModelProperty:
        const obj = this.service.reference() as (FormElement | ObjectModelRelation | ObjectModelProperty)
        if (obj) {
          return obj.referenceNameOrDefault
        } else {
          return undefined
        }
      case ReferenceNodeType.AccountRelationMetadata:
        return this.service.label;
      default:
        Logger.warnOnce('ReferencePathNode#label', 'unhandled type, defaulting.', this.reference_type)
        return this.service.label;
    }
  }
}
